import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../component/Header'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import OtherService from '../services/Other'
import { Link, useNavigate } from 'react-router-dom'
import Loader from '../component/Loader'
import Footer from '../component/Footer'
import NoData from '../component/NoData'
const DocumentGallery = () => {
    //All UseState
 const [loading, setLoading] = useState(true);
 const [isDocGallery, setIsDocGallery] = useState([]);
 const [noData, setNoData] = useState(false);
 //All useEffect
 useEffect(() => {
   const galleryFetchData = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const galleryResponse = await OtherService.gallery(token);
      if(galleryResponse.error == false)
      { 
        if(galleryResponse.data.imageDetails.length > 0)
        {
          const imageDetails = galleryResponse.data.docDetails;
          setIsDocGallery(imageDetails);
          setLoading(false)
          setNoData(false)
        }
        else{
          setLoading(false)
          setNoData(true)
        }
        
      }
      else{
        setLoading(false)
        setNoData(true)
      }
    }
     catch (error) {
       console.error('Error:');
     }

   }
   galleryFetchData()
 }, [])
 const navigate = useNavigate()
 //All Functions
 const handleDocItemDetails = (contentId) => {
   navigate(`/document-gallery/${contentId}`);
}
  return (
    <> 
    {/* {loading && <Loader/>} */}
   
    <BreadCrumbSecttion
      pageTitle="Gallery"
      currentPageName="Gallery"
    />
    <section className='padTop50'>
      <Container>
        <Row>
          <Col xs={12}>
            <div className='notificationTabList'>
              <ul>
                <li>
                   <Link to="/gallery">Photo</Link>
                </li>
                <li>
                  <Link to="/video-gallery">Video</Link>
                </li>
                <li className='active'>
                  <Link to="/document-gallery">Document</Link>
                </li>
              </ul>
            </div>
            <div className='userInfoBox'>
             
                <div className="dashboard-details">
                {noData && 
                    <Row>
                      <Col><NoData/></Col>
                    </Row>
                     }
                  <Row>

                    {isDocGallery?.map((item) => {
                      const { contentDetails, files, index } = item;
                      return (
                        <Col xs={12} lg={3} key={contentDetails.id} className='galleryImgBox'>
                          <div className='itemWrap'>
                            <div className='itemWrapImage'>
                              
                            {files.length > 0 && (
                                <img src={files[0].thumbnail_image} className='img-fluid'/>
                              )}
                                                  
                            </div>
                            <div className="itemWrapImageTxt"><p>{contentDetails.title}</p></div>
                            <PrimaryGradientButton buttonText="View More"  onClick={()=>handleDocItemDetails(contentDetails.id)}/>
                           </div>
                        </Col>
                      );
                    })}
                  </Row>
                   
                

                </div>
           
            </div>
          </Col>
        </Row>
      </Container>
    </section>
   

  </>
  )
}

export default DocumentGallery